import React, { useContext, useMemo, useState } from "react";
import { Button } from "antd";
import { actionColumnFilterOptions } from "../../../../../../../../core/constants/actionColumnFilterOptions";
import { TrackedItemTypeResponse } from "../../../../../../../../core/contracts/trackedItem/trackedItemContracts";
import { printContext } from "../../../../../../../../core/contexts/printContext";
import CustomTable from "../../../../../../../../layout/components/customTable";
import TagsModal from "../../../../../../../../layout/components/TagsMultiSelect/TagsModal";
export const UserCreatedtrackedItemsTypeTable = ({ data, actions, benchmarkListOptions, currentPage, pageSize, handleCustomTablePropChange = null, isPrintMode = false, paginationSection = null, serverPagination = false, totalCount = null, }) => {
    const { nodeRef } = useContext(printContext);
    const [tagsModalOpen, setTagsModalOpen] = useState(false);
    const [modalTags, setModalTags] = useState([]);
    const [modalSearchValue, setModalSearchValue] = useState("");
    const filteredModalTags = useMemo(() => {
        if (!modalSearchValue)
            return modalTags;
        const searchLower = modalSearchValue.toLowerCase();
        return modalTags.filter((tag) => (tag.nameLower || tag.name || tag.tagName || "")
            .toLowerCase()
            .includes(searchLower));
    }, [modalTags, modalSearchValue]);
    const columns = [
        {
            fieldName: "name",
            title: ["name"],
            className: "bold-text",
            sortable: true,
            width: 300,
            render: (text) => React.createElement("span", null, text),
        },
        {
            fieldName: "weightText",
            title: ["TrackedItem.weight"],
            filter: true,
            width: 100,
            render: (text) => React.createElement("span", null, text),
        },
        {
            fieldName: "itemCategoryText",
            title: ["TrackedItem.category"],
            width: 130,
            render: (text) => React.createElement("span", null, text),
        },
        {
            fieldName: "itemSubCategoryText",
            title: ["TrackedItem.subCategory"],
            width: 200,
            render: (text) => React.createElement("span", null, text),
        },
        {
            fieldName: "benchmarkList",
            title: ["TrackedItem.benchmarks"],
            filterInfo: {
                nestedKey: "benchmarkName",
                listing: benchmarkListOptions,
            },
            width: 130,
            render: (benchmarkList) => (React.createElement("span", null, benchmarkList === null || benchmarkList === void 0 ? void 0 : benchmarkList.map((x) => x.benchmarkName).toString())),
        },
        {
            fieldName: "hashTags",
            title: ["TrackedItem.tags"],
            width: 220,
            render: (hashTags, row) => {
                const tagsArray = Array.isArray(hashTags)
                    ? hashTags
                    : Array.isArray(row === null || row === void 0 ? void 0 : row.tagIds)
                        ? row.tagIds
                        : [];
                if (!tagsArray.length) {
                    return React.createElement("span", null, "-");
                }
                const visible = tagsArray.slice(0, 3);
                const hasMore = tagsArray.length > 3;
                return (React.createElement("div", { style: {
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "4px",
                        alignItems: "center",
                    } },
                    visible.map((tag) => (React.createElement("span", { key: tag.id || tag.tagId || tag.name, style: {
                            background: "#f0f0f0",
                            padding: "2px 8px",
                            borderRadius: "4px",
                            fontSize: "9px",
                        } },
                        React.createElement("span", null, tag.nameLower || tag.name || tag.tagName)))),
                    hasMore && (React.createElement(Button, { type: "link", size: "small", onClick: (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setModalTags(tagsArray);
                            setModalSearchValue("");
                            setTagsModalOpen(true);
                        }, style: { padding: 0 } }, "... more"))));
            },
        },
    ];
    const actionColumn = {
        fieldName: "actions",
        title: ["actions"],
        filterInfo: {
            //disabled is true in current data source DTO
            listing: actionColumnFilterOptions.map(({ text, value }) => ({
                text,
                value: !value,
            })),
            nestedKey: "disabled",
        },
        render: actions,
        width: 100,
    };
    const displayedColumns = actions ? [...columns, actionColumn] : columns;
    return (React.createElement("div", { className: "customListing", ref: nodeRef },
        React.createElement(CustomTable, { data: data, columns: displayedColumns, dataType: TrackedItemTypeResponse, 
            // scrollPosition={defaultTrackedItemTypeScrollPosition}
            itemEnableKey: "disabled", currentPage: currentPage, pageSize: pageSize, totalCount: totalCount !== null && totalCount !== void 0 ? totalCount : paginationSection === null || paginationSection === void 0 ? void 0 : paginationSection.totalRecords, scroll: false, serverSorting: true, stateParams: true, clientPagination: !isPrintMode && !serverPagination, serverPagination: serverPagination, customTablePropChange: handleCustomTablePropChange, paginationSection: paginationSection, serverSearching: true, enableClientSearch: false }),
        React.createElement(TagsModal, { open: tagsModalOpen, onClose: () => {
                setTagsModalOpen(false);
                setModalSearchValue("");
            }, tags: modalTags, searchValue: modalSearchValue, onSearchChange: (val) => setModalSearchValue(val), filteredTags: filteredModalTags, onRemoveTag: () => { }, isTagCloseable: false })));
};
